(function () {
  'use strict';

  // UK local time by arithmetic (2026-11-02): building an Intl.DateTimeFormat with a time zone cost 47-137 ms of main
  // thread on phones. BST runs from 01:00 UTC on the last Sunday of March to 01:00 UTC on the last Sunday of October.
  // Checked identical to Intl Europe/London for 121,776 timestamps across 2026-2028, including the clock changes.
  function ukNow() {
    var now = new Date(), y = now.getUTCFullYear();
    function lastSun(m) { var d = new Date(Date.UTC(y, m + 1, 0, 1)); d.setUTCDate(d.getUTCDate() - d.getUTCDay()); return d.getTime(); }
    var t = now.getTime(), uk = new Date(t + ((t >= lastSun(2) && t < lastSun(9)) ? 3600000 : 0));
    return { y: uk.getUTCFullYear(), m: uk.getUTCMonth() + 1, d: uk.getUTCDate(), h: uk.getUTCHours(), mi: uk.getUTCMinutes(), s: uk.getUTCSeconds() };
  }

  // England and Wales bank holidays (gov.uk/bank-holidays.json, checked 2 Nov 2026). The shipping policy dispatches
  // bank-holiday orders the next working day, so the countdown must not promise dispatch on these dates.
  // Plus the owner's Christmas closure (2 Nov 2026): closed 24-26 Dec 2026 and 31 Dec 2026 - 2 Jan 2027.
  var HOLIDAYS = ['2026-12-24', '2026-12-25', '2026-12-26', '2026-12-28', '2026-12-31', '2027-01-01', '2027-01-02', '2027-03-26', '2027-03-29', '2027-05-03', '2027-05-31', '2027-08-30', '2027-12-27', '2027-12-28'];
  function isHoliday(d) { return HOLIDAYS.indexOf(d.toISOString().slice(0, 10)) > -1; }

  // Get the next working day (Mon-Fri, not a bank holiday) from a given UK date.
  function nextWorkingDay(n) {
    var d = new Date(Date.UTC(n.y, n.m - 1, n.d));
    do {
      d.setUTCDate(d.getUTCDate() + 1);
    } while (d.getUTCDay() === 0 || d.getUTCDay() === 6 || isHoliday(d));
    var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return days[d.getUTCDay()] + ' ' + d.getUTCDate() + ' ' + months[d.getUTCMonth()];
  }

  function render() {
    // Countdown to 2pm UK cutoff
    document.querySelectorAll('.ts-pdp-cro__countdown').forEach(function (cd) {
      var prefix = cd.querySelector('[data-ts-countdown-prefix]');
      var value = cd.querySelector('[data-ts-countdown-value]');
      var suffix = cd.querySelector('[data-ts-countdown-suffix]');
      if (!value) return;

      var cutoff = parseInt(cd.getAttribute('data-ts-cutoff-hour'), 10) || 14;
      var n = ukNow();
      var secondsUntilCutoff = ((cutoff - n.h) * 3600) - (n.mi * 60) - n.s;
      var dow = new Date(Date.UTC(n.y, n.m - 1, n.d)).getUTCDay(); // 0=Sun..6=Sat

      var isWeekend = (dow === 0 || dow === 6 || isHoliday(new Date(Date.UTC(n.y, n.m - 1, n.d))));
      var isBeforeCutoff = (!isWeekend && secondsUntilCutoff > 0);

      if (isBeforeCutoff) {
        cd.setAttribute('data-ts-state', 'before');
        var h = Math.floor(secondsUntilCutoff / 3600);
        var m = Math.floor((secondsUntilCutoff % 3600) / 60);
        if (prefix) prefix.textContent = 'Order in ';
        value.textContent = h + 'h ' + (m < 10 ? '0' + m : m) + 'm';
        if (suffix) suffix.textContent = ' \u2014 we aim to dispatch same day';
      } else {
        cd.setAttribute('data-ts-state', 'after');
        if (prefix) prefix.textContent = 'Next dispatch day: ';
        value.textContent = nextWorkingDay(n);
        if (suffix) suffix.textContent = '';
      }
    });

    // Stock indicator
    document.querySelectorAll('[data-ts-stock-available]').forEach(function (el) {
      applyStock(el, el.getAttribute('data-ts-stock-available'));
    });
  }

  // Applies the stock state in BOTH directions. Previously this only ever set the
  // "out of stock" state, so a strip could never return to "in stock".
  function applyStock(el, v) {
    var out = (v === 'false' || v === 'null' || v === '0' || v === '' || v == null);
    el.classList.toggle('ts-pdp-cro__stock--out', out);
    el.classList.toggle('ts-pdp-cro__stock--in', !out);
  }

  // Horizon morphs the product section on variant change; the stock strip is rendered
  // outside it, so without this it kept the first variant's availability forever.
  document.addEventListener('variant:update', function (e) {
    var r = e && e.detail && e.detail.resource;
    if (!r) return;
    var v = r.available ? 'true' : 'false';
    document.querySelectorAll('[data-ts-stock-available]').forEach(function (el) {
      el.setAttribute('data-ts-stock-available', v);
      applyStock(el, v);
    });
    // The SKU line is rendered server-side for the first variant: follow the chosen one.
    document.querySelectorAll('.view-product-sku').forEach(function (el) {
      var s = el.querySelector('span');
      if (!r.sku) { el.hidden = true; return; }
      el.hidden = false;
      if (s) s.textContent = r.sku;
    });
  });

  function init() {
    render();
    setInterval(render, 60000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* a11y-audit-2026-06-29: sticky ATC name */
(function () {
  function nameStickyBtn() {
    document.querySelectorAll('.sticky-add-to-cart__button').forEach(function (b) {
      if (!b.getAttribute('aria-label')) b.setAttribute('aria-label', 'Add to cart');
    });
  }
  if (document.readyState !== 'loading') nameStickyBtn(); else document.addEventListener('DOMContentLoaded', nameStickyBtn);
  var bar = document.querySelector('sticky-add-to-cart');
  if (bar && 'MutationObserver' in window) new MutationObserver(nameStickyBtn).observe(bar, { childList: true, subtree: true });
})();
